import { IconSize } from '@ardoq/icons';
import { BlocksViewNode } from '../../types';
import { FlexBox } from '@ardoq/layout';
import { HEADER4_LINE_HEIGHT_IN_PIXELS, header4 } from '@ardoq/typography';
import styled, { css } from 'styled-components';
import { ComponentRepresentation } from '@ardoq/basic-components';
import { useRef, useLayoutEffect, useState } from 'react';

const MainLabel = styled.h4<{ $isWrapped: boolean }>`
  ${header4}
  margin: 0;
  min-width: 0;
  color: #2e3742;
  ${({ $isWrapped }) =>
    $isWrapped
      ? css`
          align-self: flex-start;
        `
      : css`
          align-self: center;
        `}
`;

type NodeTooltipComponentLabelProps = { node: BlocksViewNode };
const NodeTooltipComponentLabel = ({
  node,
}: NodeTooltipComponentLabelProps) => {
  const {
    representationData,
    color,
    labels: [mainLabel],
  } = node;

  const mainLabelRef = useRef<HTMLHeadingElement>(null);
  const [isMainLabelWrapped, setIsMainLabelWrapped] = useState(false);

  useLayoutEffect(() => {
    const { current: mainLabelElement } = mainLabelRef;
    setIsMainLabelWrapped(
      (mainLabelElement?.offsetHeight ?? 0) > HEADER4_LINE_HEIGHT_IN_PIXELS
    );
  }, [mainLabel]);

  return (
    <FlexBox gap="small" align="baseline">
      {representationData && (
        <ComponentRepresentation
          {...representationData}
          iconSize={IconSize.LARGE}
          style={{ color }}
        />
      )}
      <MainLabel ref={mainLabelRef} $isWrapped={isMainLabelWrapped}>
        {mainLabel}
      </MainLabel>
    </FlexBox>
  );
};
export { NodeTooltipComponentLabel };
